export default __webpack_public_path__ + "static/space-access-135755e2ac65e49af3424a3d48abb2df.png";